import ContentLoader from 'react-content-loader';
import type { VoidFunctionComponent } from 'react';

const TreeViewLoader: VoidFunctionComponent = () => (
  <ContentLoader
    speed={2}
    width="100%"
    height={420}
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
  >
    {/* Root folder (level 0) */}
    <rect x="8" y="12" rx="3" ry="3" width="16" height="16" />
    <rect x="28" y="14" rx="3" ry="3" width="50" height="12" />

    {/* First level item (level 1: +16px) */}
    <rect x="24" y="40" rx="3" ry="3" width="16" height="16" />
    <rect x="44" y="42" rx="3" ry="3" width="80" height="12" />

    {/* Second level items (level 2: +32px) */}
    <rect x="40" y="68" rx="3" ry="3" width="16" height="16" />
    <rect x="60" y="70" rx="3" ry="3" width="110" height="12" />

    <rect x="40" y="96" rx="3" ry="3" width="16" height="16" />
    <rect x="60" y="98" rx="3" ry="3" width="95" height="12" />

    {/* Another first level item (level 1: +16px) */}
    <rect x="24" y="124" rx="3" ry="3" width="16" height="16" />
    <rect x="44" y="126" rx="3" ry="3" width="120" height="12" />

    {/* Nested second level (level 2: +32px) */}
    <rect x="40" y="152" rx="3" ry="3" width="16" height="16" />
    <rect x="60" y="154" rx="3" ry="3" width="100" height="12" />

    {/* Third level items (level 3: +48px) */}
    <rect x="56" y="180" rx="3" ry="3" width="16" height="16" />
    <rect x="76" y="182" rx="3" ry="3" width="115" height="12" />

    <rect x="56" y="208" rx="3" ry="3" width="16" height="16" />
    <rect x="76" y="210" rx="3" ry="3" width="90" height="12" />

    {/* Fourth level items (level 4: +64px) */}
    <rect x="72" y="236" rx="3" ry="3" width="16" height="16" />
    <rect x="92" y="238" rx="3" ry="3" width="105" height="12" />

    <rect x="72" y="264" rx="3" ry="3" width="16" height="16" />
    <rect x="92" y="266" rx="3" ry="3" width="125" height="12" />

    {/* Another second level (level 2: +32px) */}
    <rect x="40" y="292" rx="3" ry="3" width="16" height="16" />
    <rect x="60" y="294" rx="3" ry="3" width="85" height="12" />

    {/* Another first level item (level 1: +16px) */}
    <rect x="24" y="320" rx="3" ry="3" width="16" height="16" />
    <rect x="44" y="322" rx="3" ry="3" width="130" height="12" />

    {/* Second level (level 2: +32px) */}
    <rect x="40" y="348" rx="3" ry="3" width="16" height="16" />
    <rect x="60" y="350" rx="3" ry="3" width="75" height="12" />

    {/* Third level (level 3: +48px) */}
    <rect x="56" y="376" rx="3" ry="3" width="16" height="16" />
    <rect x="76" y="378" rx="3" ry="3" width="95" height="12" />
  </ContentLoader>
);

export default TreeViewLoader;
